import {Brick, registerBrick} from 'olympe';

/**
 * This brick create an OR clause for the MD SAP API
 */
export default class MDAPICreateORClause extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} column
     * @param {string[]} values
     * @param {function(string)} setORClause
     */
    update($, [column, values], [setORClause]) {
        if (values.length === 0) {
            setORClause('');
        } else {
            setORClause(values.reduce((acc, val, idx, arr) => `${acc} ${column} eq '${val}' ${idx !== arr.length - 1 ? 'or ' : ')'}`, ' and ('));
        }
    }
}

registerBrick('0189b585047ad4517b52', MDAPICreateORClause);
